(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-schema"] && !Shopify.designMode) return;
  try {
    window.addEventListener('load', function() {
    if(document.getElementById('product-schema')) {
      let productSchema = JSON.parse(document.getElementById('product-schema').innerHTML);
      const schemaArray = document.querySelectorAll('script[type="application/ld+json"]:not(#product-schema)');
      schemaArray.forEach((schema) => {
        const schemaJson = JSON.parse(schema.innerHTML);
        if(schema.innerHTML.includes('aggregateRating')) {
          productSchema.aggregateRating = schemaJson.aggregateRating;
        }
        if(schemaJson['@type'] === 'Product') {
          schema.remove();
        }
      });
      productSchema = JSON.stringify(productSchema);
      document.getElementById('product-schema').innerHTML = productSchema;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
